<template>
    <div class="cemetery-public">
        <ul class="cemetery-info">
            <li v-if="cemeteryAddress">
                <div class="icon">
                    <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                        <path d="M11.5333 2.46574C15.6 6.5324 10.2 12.7991 8.46667 14.5324C8.20001 14.7991 7.79999 14.7991 7.53333 14.5324C6.26666 13.2657 3 9.5324 3 5.99906C3 2.86573 5.8 0.465736 9.06667 1.1324C10 1.26574 10.8667 1.79907 11.5333 2.46574Z" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M7.99984 8.33366C9.2885 8.33366 10.3332 7.28899 10.3332 6.00033C10.3332 4.71166 9.2885 3.66699 7.99984 3.66699C6.71117 3.66699 5.6665 4.71166 5.6665 6.00033C5.6665 7.28899 6.71117 8.33366 7.99984 8.33366Z" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <span class="address" v-html="cemeteryAddress"></span>
            </li>
            <li v-if="cemeteryWorkTime">
                <div class="icon">
                    <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                        <path d="M8 1V8L12.9333 12.9333C14.2 11.6667 15 9.93333 15 8C15 4.13333 11.8667 1 8 1Z" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M5.16574 1.60059C2.72709 2.68321 1 5.15477 1 7.99976C1 11.8664 4.13333 14.9998 8 14.9998C8.87333 14.9998 9.6994 14.8343 10.4641 14.5456" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M1 8H2.33333" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round"></path>
                        <path d="M8 14.9993V13.666" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round"></path>
                        <path d="M1.93359 11.5358L3.06689 10.8691" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round"></path>
                        <path d="M5.19987 3.06694L4.5332 1.93359" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round"></path>
                        <path d="M4.5332 14.0669L5.19987 12.9336" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round"></path>
                        <path d="M3.06689 5.19987L1.93359 4.5332" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round"></path>
                    </svg>
                </div>
                <span class="work-time" v-html="cemeteryWorkTime"></span>
            </li>
            <li v-if="cemeteryPhone">
                <div class="icon">
                    <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                        <path d="M13.6668 11.2002L11.4668 9.73353C11.0001 9.46687 10.4001 9.53353 10.0668 10.0002C9.53343 10.6002 8.93343 11.6002 6.66676 9.33353C4.33343 7.0002 5.33343 6.40019 6.0001 5.86685C6.46676 5.53352 6.53343 4.93354 6.26676 4.46687L4.8001 2.26686C4.6001 2.00019 4.33343 1.53353 3.73343 1.60019C3.13343 1.66686 1.6001 2.53354 1.6001 4.46687C1.6001 6.4002 3.13343 8.66687 5.13343 10.7335C7.2001 12.8002 9.53343 14.2669 11.4001 14.2669C13.2668 14.2669 14.2001 12.6002 14.2668 12.1335C14.3334 11.8002 13.9334 11.4002 13.6668 11.2002Z" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round"></path>
                    </svg>
                </div>
                <a class="phone" :href="`tel:${cemeteryPhone}`">{{ cemeteryPhone }}</a>
            </li>
            <li v-if="cemeteryEmail" >
                <div class="icon">
                    <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                        <path d="M13.4605 12.6663H2.53984C1.90492 12.6663 1.3335 12.1685 1.3335 11.4841V4.51525C1.3335 3.89302 1.84143 3.33301 2.53984 3.33301H13.4605C14.0954 3.33301 14.6668 3.8308 14.6668 4.51525V11.4841C14.6668 12.1685 14.1589 12.6663 13.4605 12.6663Z" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M1.96826 3.95508L7.11112 8.99506C7.61906 9.49284 8.38096 9.49284 8.88889 8.99506L14.0318 3.95508" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M1.96826 12.0441L4.66667 9.33301" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M11.3335 9.33301L14.0319 12.0441" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <a class="email" :href="`mailto:${cemeteryEmail}`">{{ cemeteryEmail }}</a>
            </li>
            <li v-if="cemeteryWebSite">
                <div class="icon">
                    <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                        <path d="M13.0745 9.24935V12.916C13.0745 13.6493 12.4745 14.2493 11.7412 14.2493H3.07454C2.34121 14.2493 1.74121 13.6493 1.74121 12.916V4.24935C1.74121 3.51602 2.34121 2.91602 3.07454 2.91602H6.74121" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M14.0583 1.94922L7.89844 8.10433" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M10.2578 1.75H13.5911C13.9911 1.75 14.2578 2.01667 14.2578 2.41667V5.75" stroke="#181429" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <a target="_blank" class="website" :href="cemeteryWebSite">{{ cemeteryWebSite }}</a>
            </li>
        </ul>
        <div class="description-wrapper" v-if="cemeteryDescription">
            <VueReadMoreSmooth :lines="5" :text="$t(`global.read-more`)" :text-less="$t(`global.read-less`)">
                <div class="description" v-html="cemeteryDescription"></div>
            </VueReadMoreSmooth>
            <!-- <div class="description-gradient"></div> -->
        </div>
    </div>
</template>

<script>
import CemeteryElementMixin from "../mixins/CemeteryElementMixin";
import VueReadMoreSmooth from "vue-read-more-smooth";
import { nl2br } from '@config/utils';

export default {
    mixins: [
        CemeteryElementMixin
    ],
    components: {
        VueReadMoreSmooth
    },
    props: {
    },
    data() {
        return {
        }
    },
    mounted() {
        // console.log('mounted view')
    },
    beforeDestroy() {
        // console.log('beforeDestroy view')
    },
    computed: {
        cemetery() {
            return this.value ?? {};
        },
        cemeteryName() {
            return this.cemetery.name;
        },
        cemeteryDescription() {
            return this.$sanitize(nl2br(this.cemetery.description));
        },
        cemeteryAddress() {
            return this.$sanitize(nl2br(this.cemetery.address));
        },
        cemeteryWorkTime() {
            return this.$sanitize(nl2br(this.cemetery.working_hours));
        },
        cemeteryPhone() {
            return this.cemetery.phone;
        },
        cemeteryEmail() {
            return this.cemetery.email;
        },
        cemeteryWebSite() {
            return this.cemetery.web_site;
        },
    },
    methods: {
    },

}
</script>

<style lang="scss" scoped>
.cemetery-public {
    .cemetery-info {
        padding: 0;
        margin: 16px 0 24px;

        li {
            display: flex;
            align-items: center;
            list-style: none;
            // font-size: 14px;

            .icon {
                background-repeat: no-repeat;
                fill: currentColor;
                margin-right: 1rem;
                min-width: 16px;
                min-height: 16px;
                width: 16px;
                height: 16px;
                display: flex;
                align-items: center;

            }

            & + li {
                margin-top: 16px;
            }

            .website,
            .email,
            .phone {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }

    .description-wrapper {
        position: relative;

        .description {
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 24px;
            opacity: 0.75;
            color: #181429;
            word-wrap: break-word;
        }

        .description-gradient {
            position: absolute;
            height: Min(56px, 75%);
            width: 100%;
            bottom: 0;
            background: linear-gradient(360deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
        }
    }
}
</style>